<div class="container-fluid grey-bg form-wrapper sign-in-wrapper">
    <div class="row">
        <div class="col-12">
            <div class="form-box">
                <div class="top-detail">
                    <a href="/" title="Back to Home"><img alt="world of sweets logo"
                            src="../../assets/images/bonds-logo-footer.svg" /></a>
                    <h1>Sign Up</h1>
                    <p>Let’s create your account.</p>
                </div>

                <form [formGroup]="signupForm" (ngSubmit)="EmailExistOrNot()" autocomplete="off">
                    <div class="form-group" style='display:none'>
                        <label>Account Number </label>
                        <input type="text" class="form-control" placeholder="1234 Main St" formControlName="account_number">
                        <div *ngIf="submitted && signupForm.controls.account_number.errors" class="error">
                            <div *ngIf="signupForm.controls.account_number.errors?.maxlength"><img src="/assets/images/error.svg" /> Account number not be greater then 50 characters</div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label>Store Name <sup>*</sup></label>
                        <input type="text" class="form-control" placeholder="Hayden Lane Stores" formControlName="store_name">
                        <div *ngIf="submitted && signupForm.controls.store_name.errors" class="error">
                            <div *ngIf="signupForm.controls.store_name.errors?.required"><img src="assets/images/error.svg" />
                                Store Name is required</div>
                            <div *ngIf="signupForm.controls.store_name.errors?.maxlength"><img src="assets/images/error.svg" />
                                    Store Name not be greater then 30 characters</div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label>Post Code<sup>*</sup></label>
                        <input type="text" class="form-control" placeholder="E.g. SW1W 0NY" formControlName="postcode">
                        <div *ngIf="submitted && signupForm.controls.postcode.errors" class="error">
                            <div *ngIf="signupForm.controls.postcode.errors?.required"><img src="assets/images/error.svg" />
                                PostCode is required</div>
                            <div *ngIf="signupForm.controls.postcode.errors?.pattern"><img src="/assets/images/error.svg" /> Post code should be valid.</div>
                            <div *ngIf="signupForm.controls.postcode.errors?.maxlength"><img src="/assets/images/error.svg" /> Post code cannot be more than 15 characters.</div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label>Number of Stores<sup>*</sup></label>
                        <input type="text" class="form-control" placeholder="E.g. 10" formControlName="number_of_stores">
                        <div *ngIf="submitted && signupForm.controls.number_of_stores.errors" class="error">
                            <div *ngIf="signupForm.controls.number_of_stores.errors?.required"><img src="assets/images/error.svg" />
                                Number of stores required</div>
                            <div *ngIf="signupForm.controls.number_of_stores.errors?.pattern"><img src="/assets/images/error.svg" /> Number of stores should be valid number.</div>
                            <div *ngIf="signupForm.controls.number_of_stores.errors?.min"><img src="/assets/images/error.svg" /> Value must be greater than 0.</div>
                            <div *ngIf="signupForm.controls.number_of_stores.errors?.max"><img src="/assets/images/error.svg" /> Value can't be greater than 999.</div>
                        </div>
                    </div>

                    <div class="divider"></div>

                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label>First Name <sup>*</sup></label>
                            <input type="text" class="form-control" placeholder="E.g. Adam" formControlName="first_name">
                            <div *ngIf="submitted && signupForm.controls.first_name.errors" class="error">
                                <div *ngIf="signupForm.controls.first_name.errors?.required"><img src="assets/images/error.svg" />
                                    Firstname is required</div>
                                <div *ngIf="signupForm.controls.first_name.errors?.maxlength"><img src="/assets/images/error.svg" /> Firstname not be greater then 30 characters</div>
                            </div>
                        </div>
                        <div class="form-group col-md-6">
                            <label>Last Name</label>
                            <input type="text" class="form-control" placeholder="E.g. Smith" formControlName="last_name">
                            <div *ngIf="submitted && signupForm.controls.last_name.errors" class="error">
                                <div *ngIf="signupForm.controls.last_name.errors?.required"><img src="assets/images/error.svg" />
                                    Lastname is required</div>
                                <div *ngIf="signupForm.controls.last_name.errors?.maxlength"><img src="/assets/images/error.svg" /> Lastname not be greater then 30 characters</div>
                                    
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label>Email address <sup>*</sup></label>
                        <input type="text" maxLength="100" class="form-control" placeholder="E.g. mert.ryder@gmail.com" formControlName="email" (keyup)="oNEmailChange()">
                        <div *ngIf="submitted && signupForm.controls.email.errors" class="error">
                            <div *ngIf="signupForm.controls.email.errors?.required"><img src="assets/images/error.svg" />
                                Email is required</div>
                            <div *ngIf="signupForm.controls.email.errors?.email"><img src="assets/images/error.svg" />
                                Email must be a valid email address</div>
                            
                        </div>
                        <div *ngIf="errMessage != ''" class="error">{{errMessage}}</div>
                    </div>
                    <div class="form-group mb-0">
                        <label>Contact No.<sup>*</sup></label>
                        <input type="text" class="form-control" placeholder="E.g. 07500 000 000" formControlName="contact_number">
                        <div *ngIf="submitted && signupForm.controls.contact_number.errors" class="error">
                            <div *ngIf="signupForm.controls.contact_number.errors?.required"><img src="assets/images/error.svg" />
                                Contact Number is required</div>
                                <div *ngIf="signupForm.controls.contact_number.errors?.pattern"><img src="/assets/images/error.svg" /> Contact Number should be valid number.</div>
                            <div *ngIf="signupForm.controls.contact_number.errors?.maxlength"><img src="/assets/images/error.svg" /> Contact Number not be greater then 20 characters</div>
                        </div>
                    </div>
                    <button type="submit" class="btn primary-btn">Sign Up</button>
                </form>
                <div class="redirect-signup">
                    <p>Already have an account? <a routerLink="/users/login" title="Sign In">Sign In</a></p>
                </div>
            </div>
            <app-footer></app-footer>
        </div>
    </div>
</div>